module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.007ad31.woff2";